var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "4_75",
    d: "M1296.97 895.415L1031.63 1066.84L901.795 873.637L1169.13 696.456L1296.97 895.415Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "4_74",
    d: "M1042.47 503.096L1168.95 696.401L901.138 873.824L775.071 680.227L1042.47 503.096Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "4_71",
    d: "M723.554 712.596L847.716 904.842L579.896 1082.27L452.738 887.509L723.554 712.596Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "4_70",
    d: "M848.064 905.104L975.211 1100.02L707.395 1277.44L580.23 1082.68L848.064 905.104Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "4_69",
    d: "M975.736 1100.36L1095.25 1283.52L826.145 1463.81L707.794 1277.79L975.736 1100.36Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "4_68",
    d: "M824.959 1463.05L1095.58 1283.47L1178.87 1409.36L1179.41 1410.17L1180.23 1409.66L1194.04 1401.08L1246.97 1483.91L959.092 1668.54L824.959 1463.05Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "4_67",
    d: "M1305.53 1730.28L1315.94 1745.43L1100.07 1884.3L965.993 1678.77L1206.02 1519.06L1289.18 1645.02L1330.49 1712.9L1305.81 1728.87L1304.94 1729.43L1305.53 1730.28Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "4_76",
    d: "M1228.39 1379.55L1229.23 1379.01L1228.69 1378.17L1146.01 1250.11L1413.73 1072.37L1551.47 1284.92L1263.15 1472.83L1210.73 1391.01L1228.39 1379.55Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "4_73",
    d: "M1042.32 502.241L788.148 670.817L758.195 623.678L757.673 622.856L756.838 623.355L719.165 645.861L591.058 448.606L884.871 261.383L1042.32 502.241Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "4_72",
    d: "M295.227 643.006L590.558 449.109L718.454 645.403L679.823 669.364L678.949 669.906L679.515 670.765L711.959 719.922L452.648 887.331L295.227 643.006Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "4_57",
    d: "M2634.35 890.584H2685.85V1126.71H2350.85V779.714H2633.35V889.584V890.584H2634.35Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "4_55",
    d: "M2373.35 1629.21V1633.71H2141.85V1314.71H2373.35V1366.71V1367.71H2374.35H2608.85V1565.21H2386.35H2385.35V1566.21V1628.21H2374.35H2373.35V1629.21Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "4_58",
    d: "M2684.85 890.58H2632.85V779.714H2972.98H3148.85V1025.71H2763.85V964.714V963.714H2762.85H2685.85V891.58V890.58H2684.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "4_59",
    d: "M3148.85 1364.71H2861.11H2763.85V1025.71H3017.71H3148.85V1364.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "4_60",
    d: "M3148.85 1710.71H2861.11H2763.85V1364.71H3017.71H3148.85V1710.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "4_61",
    d: "M2871.35 1967.81V2017.21H2626.85V1618.71H2764.09V1710.11V1711.11H2765.09H2971.62H3148.85V2048.71H2996.85V1967.81V1966.81H2995.85H2872.35H2871.35V1967.81Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "4_56",
    d: "M2385.4 1627.06V1565.71H2617.85V2017.71H2372.85V1628.06H2384.4H2385.4V1627.06Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "4_62",
    d: "M2372.85 1696.71V2017.71H2141.35V1696.71H2372.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "4_63",
    d: "M2141.85 1696.71V2017.71H1905.85V1696.71H2141.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "4_54",
    d: "M2141.85 1314.71V1633.71H1907.85V1314.71H2141.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "4_53",
    d: "M1636.85 1314.71H1907.85V1633.71H1664.85V1560.21V1559.21H1663.85H1637.85L1636.85 1314.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "4_64",
    d: "M1905.85 1696.71V2017.71H1674.85V1696.71H1905.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "4_65",
    d: "M1673.85 1696.71V2017.71H1442.85V1696.71H1673.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "4_66",
    d: "M1315.65 1744.12L1304.79 1729.47L1329.79 1713.12L1379.01 1696.71H1442.85V1969.71H1211.42L1143.71 1857.03L1315.4 1745.55L1316.29 1744.97L1315.65 1744.12Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor4);
export default __webpack_public_path__ + "static/media/select_floor_4.1300b4519aa3a1dc52032614b92f0ba9.svg";
export { ForwardRef as ReactComponent };